import React, {Component} from "react";
import "./App.scss";
import {Redirect, Route, Switch, withRouter} from "react-router-dom";

import {getCurrentUser} from "../util/APIUtils";
import {ACCESS_TOKEN} from "../constants";
import Login from "../user/login/Login";
import Signup from "../user/signup/Signup";
import Dashboard from "../component/dashboard/Dashboard";
import Profile from "../user/profile/Profile";
import AppHeader from "../common/AppHeader";
import NotFound from "../common/NotFound";
import LoadingIndicator from "../common/LoadingIndicator";
import PrivateRoute from "../common/PrivateRoute";

import {Layout, notification} from "antd";
import PayItemListOverview from "../chiti/PayItemListOverview";
import NotePage from "../component/note/NotePage";
import ChitiOverview from "../chiti/ChitiOverview";
import Landing from "../home/Landing";
import Terms from "../common/Terms";


const {Content} = Layout;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: null,
      isAuthenticated: false,
      isLoading: false
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.loadCurrentUser = this.loadCurrentUser.bind(this);
    this.handleLogin = this.handleLogin.bind(this);

    notification.config({
      placement: "topRight",
      top: 70,
      duration: 3
    });
  }

  loadCurrentUser() {
    this.setState({
      isLoading: true
    });
    getCurrentUser()
        .then(response => {
          this.setState({
            currentUser: response,
            isAuthenticated: true,
            isLoading: false
          });
        })
        .catch(() => {
          this.setState({
            isLoading: false
          });
        });
  }

  componentWillMount() {
    this.loadCurrentUser();
  }

  handleLogout(
      redirectTo = "/",
      notificationType = "success",
      description = "You're successfully logged out."
  ) {
    localStorage.removeItem(ACCESS_TOKEN);

    this.setState({
      currentUser: null,
      isAuthenticated: false
    });

    this.props.history.push(redirectTo);

    notification[notificationType]({
      message: "Chiti",
      description: description
    });
  }

  handleLogin() {
    notification.success({
      message: ";)",
      description: "You're successfully logged in."
    });
    this.loadCurrentUser();
    this.props.history.push("/");
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingIndicator/>;
    }
    return (
        <Layout className="app-container">
          <AppHeader
              isAuthenticated={this.state.isAuthenticated}
              currentUser={this.state.currentUser}
              onLogout={this.handleLogout}
          />

          <Content className="app-content">
            <div className="container">
              <Switch>
                <Route exact path="/"
                       render={() => this.state.isAuthenticated ? <Redirect to="/home"/> : <Landing/>}/>
                <PrivateRoute
                    authenticated={this.state.isAuthenticated}
                    path="/home"
                    component={Dashboard}
                    isAuthenticated={this.state.isAuthenticated}
                    handleLogout={this.handleLogout}
                />
                <Route
                    path="/users/:username"
                    render={props => (
                        <Profile
                            isAuthenticated={this.state.isAuthenticated}
                            currentUser={this.state.currentUser}
                            {...props}
                        />
                    )}
                />
                <Route
                    path="/login"
                    render={props => (
                        <Login onLogin={this.handleLogin} {...props} />
                    )}
                />
                {<Route path="/signup" component={Signup}/>}

                <Route path="/terms" component={Terms} />

                <PrivateRoute
                    authenticated={this.state.isAuthenticated}
                    path="/chiti/list/overview"
                    component={PayItemListOverview}
                    handleLogout={this.handleLogout}
                />
                <PrivateRoute
                    authenticated={this.state.isAuthenticated}
                    path="/chiti/note"
                    component={NotePage}
                    handleLogout={this.handleLogout}
                />
                <PrivateRoute
                    authenticated={this.state.isAuthenticated}
                    path="/chiti/overview"
                    component={ChitiOverview}
                    handleLogout={this.handleLogout}
                />

                <Route component={NotFound}/>
              </Switch>
            </div>
          </Content>

        </Layout>
    );
  }
}

export default withRouter(App);
